import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";

import * as Auth from "fond/cognito/auth";
import { getAllAttrs } from "fond/cognito/aws_cognito_utils";
import { CognitoAction } from "fond/cognito/redux";
import { RETURN_URL } from "fond/constants";
import { Store } from "fond/types";
import { useAppDispatch } from "fond/utils/hooks";

import BlockSpinner from "./widgets/BlockSpinner";

const PrivateRouteWrapper: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const currentUsername = useSelector((state: Store) => state.cognito.user?.username);
  const [loaded, setLoaded] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);

  const authenticate = useCallback(() => {
    const returnUrl = encodeURIComponent(`${window.location.pathname}${window.location.search}`);
    Auth.currentAuthenticatedUser()
      .then(async (user) => {
        if (!currentUsername) {
          dispatch({
            type: CognitoAction.AUTHENTICATED,
            user,
            userAttrs: await getAllAttrs(user),
          });
        }
        setAuthenticated(true);
        setLoaded(true);
      })
      .catch(() => {
        navigate(`/signin?${RETURN_URL}=${returnUrl}`);
      });
  }, [dispatch, navigate, currentUsername]);

  useEffect(() => {
    authenticate();
  }, [authenticate]);

  useEffect(() => {
    Auth.currentAuthenticatedUser().catch(() => {
      if (authenticated) {
        setAuthenticated(false);
      }
    });
  }, [authenticated, location]);

  if (!loaded) {
    return <BlockSpinner containerProps={{ height: "100%" }} />;
  } else if (authenticated) {
    return <Outlet />;
  } else {
    return <Navigate to="/signin" />;
  }
};

export default PrivateRouteWrapper;
